import { ContainerComponent, wrap, today } from 'AppReact';
import Controller from './controller';
import {
  AbsoluteLeftTopWrapper, Mt3, CustomBorderWrapper,
  CustomHeight, NotPaddedGrowWrapper, Mx4, Mt4, Px3,
  ColumnBetweenWrapper, Mb4, BorderLeftWrapper, Mb2,
  BorderBottomWrapper, MediaListScrollWrapper, Mt10,
  Width350, FlexBoxWrapper, AbsolutePositionWrapper
} from 'wrappers';
import internalState from './internalState';
import { addYears } from 'date-fns';
import { CloseSquareSvg } from 'components/icons';
import React from 'react';
import { IconTextButton, TabButton } from 'molecules';
import CalendarMonth from '../calendarMonth';
import CustomDatePickerButtons from '../customDatePickerButtons';
import { getSelectedTimeByDate, getIsMobile } from 'utils';

const isMobile = getIsMobile();

const monthListRef = React.createRef();
const yearListRef = React.createRef();

export const definition = {
  name: 'CustomDatePicker',
  controller: Controller,
  initialProps: ({ selectedDate }) => ({
    selectedTimeOption: selectedDate ? getSelectedTimeByDate(selectedDate) : null,
    selectedDate,
    selectedYear: selectedDate?.getFullYear() ?? today().getFullYear(),
    yearListRef,
    monthListRef
  }),
  props: internalState,
  elements: [
    {
      wrapper: isMobile ? AbsolutePositionWrapper : AbsoluteLeftTopWrapper,
      displayState: ({ }) => ({ top: isMobile ? '35px' : '50px', width: isMobile ? '320px' : '500px', left: isMobile ? '50%' : '-400px', transform: isMobile ? 'translateX(-50%)' : '' }),
      name: 'Wrapper',
      elements: [
        {
          wrapper: CustomBorderWrapper,
          name: 'BorderWrapper',
          displayState: ({ }) => ({ borderRadius: '8px', border: '1px solid #E3E3E3', background: '#FFFFFF' }),
          elements: [
            {
              wrapper: FlexBoxWrapper,
              name: 'CalendarWrapper',
              elements: [
                {
                  wrapper: ColumnBetweenWrapper,
                  name: 'LeftSideWrapper',
                  renderIf: ({ }) => !isMobile,
                  elements: [
                    {
                      component: wrap(CustomDatePickerButtons, Mt3),
                      name: 'CustomButtons',
                      bindings: ({ selectedDate, selectedTimeOption }) => ({ selectedDate, selectedTimeOption, yearListRef, monthListRef })
                    },
                    {
                      component: wrap(wrap(wrap(IconTextButton, FlexBoxWrapper), Mx4), Mb4),
                      name: 'Reset',
                      bindings: ({ inspection }) => ({ inspection, icon: CloseSquareSvg({ width: '17', height: '17', color: 'red' }), title: 'Clear' })
                    },
                  ]
                },
                {
                  wrapper: BorderLeftWrapper,
                  name: 'RightSideWrapper',
                  elements: [
                    {
                      wrapper: CustomHeight,
                      name: 'ListWrapper',
                      displayState: ({ }) => ({ height: isMobile ? 430 : 566, display: 'flex', flexDirection: 'column', width: '370px' }),
                      elements: [
                        {
                          wrapper: wrap(wrap(wrap(MediaListScrollWrapper, Width350), BorderBottomWrapper), Mx4),
                          name: 'YearList',
                          ref: yearListRef,
                          elements: [
                            {
                              component: wrap(wrap(TabButton, Mb2), Mt4),
                              isListOf: { year: ({ }) => Array.from(Array(60).keys()) },
                              name: 'Year',
                              bindings: ({ year, selectedDate }) => {
                                const futureYear = addYears(today(), year).getFullYear();
                                return { title: futureYear.toString(), year: futureYear, selectedDate, monthListRef }
                              },
                              displayState: ({ selectedYear, year }) => {
                                const futureYear = addYears(today(), year).getFullYear();
                                return { fontSize: 12, selected: selectedYear === futureYear }
                              }
                            }
                          ]
                        },
                        {
                          wrapper: NotPaddedGrowWrapper,
                          name: 'ListWrapper',
                          ref: monthListRef,
                          elements: [
                            {
                              component: wrap(wrap(CalendarMonth, Mt10), Px3),
                              isListOf: { month: ({}) =>  Array.from(Array(12).keys())},
                              name: 'Month',
                              bindings: ({ month, selectedYear, selectedDate }) => {
                                return {
                                  year: selectedYear,
                                  month: month,
                                  selectedDates: selectedDate ? [selectedDate] : [],
                                  showToday: true,
                                  disabledBefore: today()
                                }
                              }
                            }
                          ]
                        },
                      ]
                    },
                  ]
                }
              ]
            }

          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition)